import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';

// Use environment variable for encryption key
const ENCRYPTION_KEY = process.env.REACT_APP_COOKIE_ENCRYPTION_KEY || 'your-secret-key-min-32-chars-long!';

// Generate a secure key (you can use this to generate a key for production)
export const generateEncryptionKey = () => {
  return CryptoJS.lib.WordArray.random(256/8).toString();
};

// Encrypt data before storing
export const encryptData = (data) => {
  try {
    const encrypted = CryptoJS.AES.encrypt(data, ENCRYPTION_KEY).toString();
    return encrypted;
  } catch (error) {
    console.error('Encryption error:', error);
    return null;
  }
};

// Decrypt data after retrieving
export const decryptData = (encryptedData) => {
  try {
    if (!encryptedData) return null;
    const decrypted = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
    const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
    return decryptedString;
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
};

// Set encrypted cookie
export const setEncryptedCookie = (key, value, options = {}) => {
  try {
    const encryptedValue = encryptData(value);
    if (encryptedValue) {
      Cookies.set(key, encryptedValue, options);
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error setting encrypted cookie:', error);
    return false;
  }
};

// Get decrypted cookie
export const getDecryptedCookie = (key) => {
  try {
    const encryptedValue = Cookies.get(key);
    if (!encryptedValue) return null;
    const decryptedValue = decryptData(encryptedValue);
    return decryptedValue;
  } catch (error) {
    console.error('Error getting decrypted cookie:', error);
    return null;
  }
};

// Remove cookie
export const removeEncryptedCookie = (key) => {
  Cookies.remove(key);
};

// Check if cookie exists and is valid
export const isValidEncryptedCookie = (key) => {
  try {
    const encryptedValue = Cookies.get(key);
    if (!encryptedValue) return false;
    const decryptedValue = decryptData(encryptedValue);
    return decryptedValue !== null && decryptedValue !== '';
  } catch (error) {
    return false;
  }
};